import { Component, Injector, OnDestroy } from '@angular/core';
import { CustomizeService } from './shared/service/customizer.service';
import { Router, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import { SoundService } from './shared/service/sound.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  currentPage: string;
  isAbsolutePosition: string;
  atmosphere: boolean = false;

  constructor(public customize: CustomizeService,
    private router: Router, public sound: SoundService, public translate: TranslateService) {

      let language: string = document.URL.split('/')[3];
        if(language === 'ua' || language === 'en'){
          translate.use(language);
        }
        else{
          const browserLang = translate.getBrowserLang();
          let language = browserLang.match(/ua|ru/) ? 'ua' : 'en';
          translate.use(language);
          router.navigateByUrl(language);
        }

    router.events.filter(event => event instanceof NavigationEnd)
      .subscribe(event => {
        event = event as NavigationEnd;

        if (event.url.includes('about')) {
          this.currentPage = "about";
          this.isAbsolutePosition = "false";
        } else if (event.url.includes('contact')) {
          this.currentPage = "contact";
          this.isAbsolutePosition = "false";
        } else if (event.url.includes('blog')) {
          this.currentPage = "blog";
          this.isAbsolutePosition = "false";
        } else if (event.url.includes('comingsoon')) {
          this.currentPage = "all";
          this.isAbsolutePosition = "false";
        } else if (event.url.includes('policy')) {
          this.currentPage = "policy";
          this.isAbsolutePosition = "false";
        }
        else if (event.url.includes('calculator') ||
          event.url.includes('optimization') ||
          event.url.includes('maintenance') ||
          event.url.includes('development') ||
          event.url.includes('enterprise') ||
          event.url.includes('optimization') ||
          event.url.includes('datascience') || 
          event.url.includes('visualization')) {
          this.currentPage = "services";
          this.isAbsolutePosition = "true";
        } else if (event.url.includes('faq')) {
          this.currentPage = "faq";
          this.isAbsolutePosition = "false";
        } else {
          this.currentPage = "main";
          this.isAbsolutePosition = "true";
        }
      });
  }

  customizeLayoutVersion(val) {

    let tooltip = document.getElementById('tooltip');
    let img = document.getElementById('footerImg') as HTMLImageElement;

    if (val == "dark") {

      tooltip = document.getElementById('tooltip');
      tooltip.classList.add('hideTip');

      img.src = "assets/images/logo/logo-footer-dark.png";

      // setTimeout(() => {
      //   document.body.classList.add('removeAnimation');
      // }, 5000)

      // setTimeout(() => {
      //   this.sound.turnOnAtmosphere();
      //   this.sound.turnOnbutton-sound();
      //   this.sound.turnOnlink-sound();
      // }, 1600);

    } else {
      img.src = "assets/images/logo/logo-footer.png";
      tooltip.classList.remove('hideTip');
      document.body.classList.remove('removeAnimation');
      this.sound.turnOffAtmosphere();
    }

    this.customize.setLayoutVersion(val);
    this.sound.changeAtmosphere(val);
    this.atmosphere = !this.atmosphere;
  }

  ngOnDestroy() {
    this.customize.data.settings.layout_version = "light";
  }
}
